import { automationsRepo } from '@/constants/providers';
import { ApiResponse } from '@/shared/types';
import { useMutation } from '@tanstack/react-query';

export const useEnableAutomation = () =>
  useMutation<ApiResponse<unknown>, unknown, number>((id) =>
    automationsRepo.enableAutomation(id),
  );
